/******************************************************************************
 * Memokid: A game to train one's memory                                      *
 * Copyright (C) 2022 Lukas Laag                                              *
 * This file is part of Memokid                                               *
 *                                                                            *
 * Memokid is free software: you can redistribute it and/or modify            *
 * it under the terms of the GNU General Public License as published by       *
 * the Free Software Foundation, either version 3 of the License, or          *
 * (at your option) any later version.                                        *
 *                                                                            *
 * Memokid is distributed in the hope that it will be useful,                 *
 * but WITHOUT ANY WARRANTY; without even the implied warranty of             *
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the              *
 * GNU General Public License for more details.                               *
 *                                                                            *
 * You should have received a copy of the GNU General Public License          *
 * along with Memokid.  If not, see <https://www.gnu.org/licenses/>.          *
 *                                                                            *
 ******************************************************************************/

import { createStore, applyMiddleware, compose } from 'redux'
import thunkMiddleware from 'redux-thunk'
import { gameReducer } from './reducers/game'
import { defaultState } from './actions/game'
import { autoRehydrate } from 'redux-persist'

// Mise en place du middleware

const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose
const newStore = () => createStore(
  gameReducer,
  defaultState(),
  composeEnhancers(
    applyMiddleware(thunkMiddleware),
    autoRehydrate()
  )
)
export default newStore
/*
createStore(
  gameReducer,
  DEFAULT_STATE, compose(
    applyMiddleware(routerMiddleware(browserHistory), thunkMiddleware)
))
*/
